// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5o-0";
export var eligibilityCardNotEligible = "_5o-1";